import { observer } from 'mobx-react-lite';
import { BrandCreateDto } from '~/shared/dto/admin/brand.dto';
import { BrandId } from '~/shared/dto/id';
import { Form } from '~/shared/form';
import { FieldNumber } from '~/view/fields/field.number';
import { FieldSwitch } from '~/view/fields/field.switch';
import { FieldText } from '~/view/fields/field.text';
import { FieldTextArray } from '~/view/fields/field.textarray';

export const BrandGeneral = observer<{ id: BrandId; form: Form<BrandCreateDto> }>(({ id, form }) => {
	return (
		<>
			<FieldNumber disabled={!!id} field={form.$id} />
			<FieldText field={form.$name} />
			<FieldText field={form.$description} multiline />
			<FieldText field={form.$country} />
			<FieldNumber field={form.$year} />
			<FieldTextArray field={form.$synonyms} multiline />
			<FieldText multiline field={form.$comment} />
			<FieldSwitch field={form.$active} />
		</>
	);
});
